import script from "./ParticipantSectionGroup.vue?vue&type=script&setup=true&lang=js"
export * from "./ParticipantSectionGroup.vue?vue&type=script&setup=true&lang=js"

import "./ParticipantSectionGroup.vue?vue&type=style&index=0&id=7d5a5063&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d5a5063"]])

export default __exports__